/* bd-v155 (2026-09-07): vergelijkingstabel standaard ingeklapt.
   De tabel is 466 px hoog, heeft 10 rijen en bevat 12 van de 52 prijzen op de
   pagina. Ingeklapt scheelt dat keuzestress; de knop laat onmiskenbaar zien
   dat de vergelijking er is. Opent vanzelf bij #compare in de URL. */
(function () {
  'use strict';

  // Instellingen uit de theme-editor; zonder instellingen dezelfde teksten.
  var CFG = (window.BD_V149 && window.BD_V149.compare) || {};
  function woord(v, terugval) {
    return (typeof v === 'string' && v.length) ? v : terugval;
  }
  var TITEL = woord(CFG.title, 'Compare all three toolkits side by side');
  var SUB = woord(CFG.sub, 'What is included, delivery and access');
  var TOON = woord(CFG.show, 'Show table');
  var VERBERG = woord(CFG.hide, 'Hide table');
  var STANDAARD_OPEN = CFG.open === true;

  function veilig(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  var CSS = [
    '.bd-compare{display:block;margin:6px 0 0}',
    '.bd-compare__toggle{list-style:none;cursor:pointer;display:flex;align-items:center;gap:14px;',
    'width:100%;padding:16px 18px;border:1px solid rgba(var(--color-foreground,11 18 32),.16);',
    'border-radius:14px;background:rgb(var(--color-background,255 255 255));',
    'box-shadow:0 1px 2px rgba(0,0,0,.04);transition:border-color .15s ease,box-shadow .15s ease}',
    '.bd-compare__toggle::-webkit-details-marker{display:none}',
    '.bd-compare__toggle:hover{border-color:rgb(var(--color-button,31 86 229));box-shadow:0 2px 10px -4px rgba(31,86,229,.35)}',
    '.bd-compare__toggle:focus-visible{outline:2px solid rgb(var(--color-button,31 86 229));outline-offset:2px}',
    '.bd-compare__icon{flex:0 0 auto;width:38px;height:38px;border-radius:10px;display:grid;place-items:center;',
    'background:rgba(var(--color-button,31 86 229),.10);color:rgb(var(--color-button,31 86 229));font-size:19px;line-height:1}',
    '.bd-compare__txt{flex:1 1 auto;min-width:0;text-align:left}',
    '.bd-compare__ttl{display:block;font-size:16px;font-weight:700;letter-spacing:-.01em;line-height:1.25}',
    '.bd-compare__sub{display:block;font-size:13px;line-height:1.35;margin-top:2px;color:rgba(var(--color-foreground,11 18 32),.62)}',
    '.bd-compare__chev{flex:0 0 auto;color:rgb(var(--color-button,31 86 229));font-weight:700;font-size:13px;',
    'display:inline-flex;align-items:center;gap:6px;white-space:nowrap}',
    '.bd-compare__chev svg{width:16px;height:16px;transition:transform .2s ease}',
    '.bd-compare[open] .bd-compare__chev svg{transform:rotate(180deg)}',
    '.bd-compare[open] .bd-compare__toggle{border-color:rgb(var(--color-button,31 86 229));',
    'border-bottom-left-radius:0;border-bottom-right-radius:0}',
    '.bd-compare__body{border:1px solid rgb(var(--color-button,31 86 229));border-top:0;',
    'border-radius:0 0 14px 14px;padding:6px 12px 12px;overflow-x:auto}',
    '@media screen and (max-width:559px){',
    '.bd-compare__toggle{padding:14px}.bd-compare__ttl{font-size:15px}.bd-compare__sub{font-size:12px}',
    '.bd-compare__chev span{display:none}}'
  ].join('');

  function stijl() {
    if (document.getElementById('bd-compare-css')) return;
    var s = document.createElement('style');
    s.id = 'bd-compare-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function start() {
    var tabel = document.querySelector('.bd-v33-comparison__table');
    if (!tabel || tabel.closest('.bd-compare')) return;

    // Pak de scroll-omhulling als die er is, anders de tabel zelf.
    var doel = tabel.parentElement && /scroll|overflow|wrapper|table/i.test(tabel.parentElement.className || '')
      ? tabel.parentElement : tabel;

    // Alleen echte vergelijkingsrijen tellen. tabel.rows telt de kopregel mee,
    // en die is geen vergelijkingspunt: 1 thead + 9 tbody gaf ten onrechte 10.
    var rijen = 0;
    if (tabel.tBodies && tabel.tBodies.length) {
      for (var b = 0; b < tabel.tBodies.length; b++) rijen += tabel.tBodies[b].rows.length;
    } else if (tabel.rows) {
      rijen = tabel.rows.length - (tabel.tHead ? tabel.tHead.rows.length : 0);
    }

    stijl();

    var det = document.createElement('details');
    det.className = 'bd-compare';
    det.innerHTML =
      '<summary class="bd-compare__toggle">' +
        '<span class="bd-compare__icon" aria-hidden="true">☷</span>' +
        '<span class="bd-compare__txt">' +
          '<span class="bd-compare__ttl">' + veilig(TITEL) + '</span>' +
          '<span class="bd-compare__sub">' + veilig(SUB) +
            (rijen ? ' · ' + rijen + ' points' : '') + '</span>' +
        '</span>' +
        '<span class="bd-compare__chev"><span>' + veilig(TOON) + '</span>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" ' +
          'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>' +
        '</span>' +
      '</summary>' +
      '<div class="bd-compare__body"></div>';

    doel.parentNode.insertBefore(det, doel);
    det.querySelector('.bd-compare__body').appendChild(doel);

    // Knoptekst wisselt mee, zodat de staat ook zonder icoon duidelijk is.
    var label = det.querySelector('.bd-compare__chev span');
    det.addEventListener('toggle', function () {
      if (label) label.textContent = det.open ? VERBERG : TOON;
    });

    // Direct open bij een link naar de vergelijking, of als de instelling
    // "standaard open" aan staat.
    if (STANDAARD_OPEN) det.open = true;
    if (/compare|vergelijk/i.test(location.hash)) det.open = true;
    if (det.open && label) label.textContent = VERBERG;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="compare"],a[href*="vergelijk"]');
      if (a) det.open = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
